import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import "./i18n";
import { AuthProvider } from "./contexts/UserContext";
import { enforceBrowserSession } from "./utils/secureLocalStorage";

// Must run before the first reader of the session, so a restarted browser never renders as signed in.
enforceBrowserSession();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ThemeProvider>

  // <React.StrictMode>
  //   <ThemeProvider theme={theme}>
  //     <AuthProvider>
  //       <App />
  //     </AuthProvider>
  //   </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
